import $ from 'jquery'

let ScrollMagic = null
let scrollMagicController = null
let sceneStack = []

async function init () {
  if ($('.interim-explorer-module').length > 0 || $('.interim-explorer-module-small').length > 0) {
    const ScrollMagicLib = await import(/* webpackChunkName: "scrollmagic" */ 'scrollmagic/scrollmagic/uncompressed/ScrollMagic')
    ScrollMagic = ScrollMagicLib.default
    scrollMagicController = new ScrollMagic.Controller({ globalSceneOptions: { triggerHook: 'onEnter' } })
  }
  $('.interim-explorer-module').each(function () {
    if (!$(this).hasClass('edit-mode')) {
      initInterimExplorerModule($(this))
    }
  })

  $('.interim-explorer-module-small').each(function () {
    if (!$(this).hasClass('edit-mode')) {
      initInterimExplorerModuleSmall($(this))
    }
  })
}

function initInterimExplorerModule (container) {
  let bigScrollMagic = new ScrollMagic.Scene({
    triggerElement: container.find('.explorer-trigger').get(0),
    duration: durationCalculator(container)
  })
    .on('progress', (e) => {
      let content = container.find('.explorer-container'),
        profileImage = container.find('.explorer-teaser-image')
      if ($(window).width() > 768) {
        if (e.progress < 0.5) {
          content.addClass('animate')
          profileImage.addClass('animate')
        } else {
          content.removeClass('animate')
          profileImage.removeClass('animate')
        }
      } else {
        if (e.progress < 0.25) {
          profileImage.addClass('animate')
        } else {
          profileImage.removeClass('animate')
          content.removeClass('animate')
        }
      }
    })
    .addTo(scrollMagicController)

  sceneStack.push(bigScrollMagic)

  $(window).on('resize', () => {
    bigScrollMagic.duration(durationCalculator(container))
  })

  function durationCalculator (container) {
    let duration
    if ($(window).width() > 991) {
      duration = container.outerHeight(true)
    } else {
      if (container.find('.explorer-teaser-image').length > 0) {
        duration = container.outerHeight(true) / 2
      } else {
        duration = 0
      }
    }
    return duration
  }
}

function initInterimExplorerModuleSmall ($container) {
  var $triggerElem = $container.find('.explorer-trigger').get(0),
    scrollMagicScene,
    $closeButton = $container.find('.explorer-small-close-button'),
    $expandButton = $container.find('.ff-click-handler')

  if ($(window).width() < 992) {
    $container.addClass('closed')
  }

  scrollMagicScene = new ScrollMagic.Scene({
    triggerElement: $triggerElem,
    duration: '150%'
  })
    .on('enter', function (e) {
      $container.removeClass('collapsed')
    })
    .on('leave', function (e) {
      $container.addClass('collapsed')
    })
    .addTo(scrollMagicController)

  $closeButton.on('click', function (e) {
    if (!$container.hasClass('collapsed') && !$container.hasClass('closing') && !$container.hasClass('opening')) {
      $container.addClass('closing')
      setTimeout(function () {
        $container.removeClass('closing')
        $container.addClass('closed')
      }, 1000)
    }
  })
  $expandButton.on('click', function (e) {
    if ($container.hasClass('closed')) {
      $container.removeClass('closed')
      $container.addClass('opening')
      setTimeout(function () {
        $container.removeClass('opening')
      }, 500)
    }
  })
}

export default {
  init
}
